const staticPrefix = 'website-static'

enum assetsPrefix {
  SELECTION_STARS = 'selection-stars-label',
}

const prepareAssetLabel = (label: string, prefix?: string) =>
  prefix ? `${staticPrefix}-${prefix}-${label}` : `${staticPrefix}-${label}`

export const StaticAssets = {
  SelectionStarsLabelRelance: prepareAssetLabel(
    'relance',
    assetsPrefix.SELECTION_STARS
  ),
  SelectionStarsLabelISR: prepareAssetLabel(
    'isr',
    assetsPrefix.SELECTION_STARS
  ),
  SelectionStarsLabelTS: prepareAssetLabel(
    'toward-sustainability',
    assetsPrefix.SELECTION_STARS
  ),
  SelectionStarsLabelLuxflag: prepareAssetLabel(
    'luxflag',
    assetsPrefix.SELECTION_STARS
  ),
}

export enum StarsLabels {
  ISR = 'Label ISR',
  TOWARD_SUBSTAIN = 'Toward Sustainability',
  LUXFLAG = 'Luxflag',
  RELANCE = 'Label Relance',
}

export const StarsLabelMapping: Utils.Object<string, StarsLabels | string> = {
  [StarsLabels.ISR]: StaticAssets.SelectionStarsLabelISR,
  [StarsLabels.TOWARD_SUBSTAIN]: StaticAssets.SelectionStarsLabelTS,
  [StarsLabels.LUXFLAG]: StaticAssets.SelectionStarsLabelLuxflag,
  [StarsLabels.RELANCE]: StaticAssets.SelectionStarsLabelRelance,
}

export enum inbentaProductCategories {
  COMPTE_BANCAIRE = 'compte-bancaire',
  EPARGNE = 'epargne',
  ASSURANCE_VIE = 'assurance-vie',
  BOURSE = 'bourse',
  CREDIT_IMMOBILIER = 'credit-immobilier',
  PRET_PERSONNEL = 'pret-personnel',
}

export const inbentaSearchCategoryMapping = {
  [inbentaProductCategories.ASSURANCE_VIE]: 'Assurance-vie',
  [inbentaProductCategories.BOURSE]: 'Bourse',
  [inbentaProductCategories.COMPTE_BANCAIRE]: 'Compte bancaire',
  [inbentaProductCategories.CREDIT_IMMOBILIER]: 'Crédit immobilier',
  [inbentaProductCategories.EPARGNE]: 'Épargne',
  [inbentaProductCategories.PRET_PERSONNEL]: 'Prêt personnel',
}
